import { TeammateStatusEnum, TeammateRoleEnum } from 'api/backofficeApiClient';

const getTeammateStatusLabel = (status: TeammateStatusEnum) => {
  switch (status) {
    case TeammateStatusEnum.InActive:

      return 'Inactive';
    case TeammateStatusEnum.Active:
      return 'Active';

    case TeammateStatusEnum.Pending:
      return 'Pending';
  }
};

const getTeammateRoleLabel = (role?: TeammateRoleEnum) => {
  switch (role) {
    case TeammateRoleEnum.TeammateAdmin:
      return 'Admin';
    case TeammateRoleEnum.TeammateRecruiter:
      return 'Recruiter';
    case TeammateRoleEnum.TeammateSubAdmin:
      return 'Sub-admin';
    default:
      return 'Teammate';
  }
};

const getTeammateRoleOptions = [
  {
    value: TeammateRoleEnum.TeammateRecruiter,
    label: getTeammateRoleLabel(TeammateRoleEnum.TeammateRecruiter),
  },
  {
    value: TeammateRoleEnum.TeammateSubAdmin,
    label: getTeammateRoleLabel(TeammateRoleEnum.TeammateSubAdmin),
  },
  {
    value: TeammateRoleEnum.TeammateAdmin,
    label: getTeammateRoleLabel(TeammateRoleEnum.TeammateAdmin),
  },
];

export { getTeammateStatusLabel, getTeammateRoleLabel, getTeammateRoleOptions };
